import axios, { GenericAbortSignal } from 'axios'
import { useEffect, useState } from 'react'

interface UseShippingOrderLoaderParams {
  id?: string
  getShippingOrderById: (
    id: string,
    signal?: GenericAbortSignal,
  ) => Promise<unknown>
}

export const useShippingOrderLoader = ({
  id,
  getShippingOrderById,
}: UseShippingOrderLoaderParams) => {
  const [isOrderLoading, setIsOrderLoading] = useState(false)

  useEffect(() => {
    if (!id) {
      return
    }

    const controller = new AbortController()

    setIsOrderLoading(true)

    const loadOrder = async () => {
      try {
        await getShippingOrderById(id, controller.signal)
      } catch (error) {
        if (axios.isCancel(error)) {
          return
        }
      } finally {
        if (!controller.signal.aborted) {
          setIsOrderLoading(false)
        }
      }
    }

    loadOrder()

    return () => {
      controller.abort()
    }
  }, [getShippingOrderById, id])

  return { isOrderLoading }
}
